import { useEffect, useState, useRef } from "react";

import styles from "./Face2.module.scss";

export default function Face2() {
  const cardRef = useRef<HTMLDivElement>(null);

  const [fontSize, setFontSize] = useState<number | undefined>(undefined);
  const [letterSpacing, setLetterSpacing] = useState<number | undefined>(
    undefined,
  );
  const [lineHeight, setLineHeight] = useState<number | undefined>(undefined);
  const [marginLeft, setMarginLeft] = useState<number | undefined>(undefined);

  useEffect(() => {
    // Handler to call on window resize
    function handleResize() {
      if (cardRef.current) {
        setFontSize(Math.floor(0.04 * cardRef.current.clientWidth));
        setLetterSpacing(0.002 * cardRef.current.clientWidth);
        setLineHeight(0.05 * cardRef.current.clientWidth);
        setMarginLeft(0.4 * cardRef.current.clientWidth);
      }
    }

    // Add event listener
    window.addEventListener("resize", handleResize);
    // Call handler right away so state gets updated with initial window size
    handleResize();
    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", handleResize);
  }, []); // Empty array ensures that effect is only run on mount

  return (
    <div ref={cardRef} className={styles.card}>
      <div
        style={{
          fontSize: `${fontSize}px`,
          letterSpacing: `${letterSpacing}px`,
          lineHeight: `${lineHeight}px`,
          marginLeft: `${marginLeft}px`,
          width: "100%",
        }}
      >
        <p>It's like walking in the dense woods</p>
        <p>and getting to a sudden clearing</p>
        <p>with an obvious altar</p>
        <br></br>
        <p>It's flying on a tiny plane</p>
        <p>juggling deathwish and ecstatic delirium</p>
        <p>over the sound of the motor</p>
        <br></br>
        <p>Same as standing in Sainte-Chapelle</p>
        <p>and getting a satisfying confirmation</p>
        <p>of own unimportance</p>
        <br></br>
        <p>It's like us sucking on unripe plums</p>
        <p>trying to match the brutal burst</p>
        <p>of our adolescence</p>
        <br></br>
        <p>It is me loving you so hard</p>
        <p>Until you decided to love me back!</p>
        <p>But Gasp and so Late</p>
        <p>a major-minuscule mistake.</p>
      </div>
    </div>
  );
}
